import {GIH_FAILURE, GIH_PENDING, GIH_SUCCESS} from './constants'
import {getAssignedTo as getAssignedToAPI} from '../../../services/audits'

export async function getAssignedTo(data, dispatch) {
  dispatch({type: GIH_PENDING, payload: data})
  try {
    let response = await getAssignedToAPI(data)
    dispatch({type: GIH_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Item History Failed`)
    dispatch({type: GIH_FAILURE, payload: e})
  }
}
